import React from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import * as Icons from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toggleSidebar, logout } from 'redux/actions';

const ItemContent = ({ name, link, icon, isNextDivider, id }) => {
    const nameClasses = cx('item__name', { 'item__name-border': !isNextDivider });
    const Icon = Icons[icon];
    const dispatch = useDispatch();

    const handleOpen = (e) => {
        return setTimeout(() => {
            dispatch(toggleSidebar());
        }, 500);
    };

    const handleLogout = () => dispatch(logout())

    return (
        <li className="sidebar__item">
            <NavLink
                activeClassName={id !== 'sidebar-logout' ? 'is-active' : 'is-button'}
                to={id === 'sidebar-logout' ? '#' : link}
                className="item"
                onClick={() => (id === 'sidebar-logout' ? handleLogout() : handleOpen())}
            >
                <span className="item__icon">
                    <Icon />
                </span>
                <span className={nameClasses}>{name}</span>
            </NavLink>
        </li>
    );
};

ItemContent.propTypes = {
    name: PropTypes.string,
    link: PropTypes.string,
    icon: PropTypes.string,
    isNextDivider: PropTypes.bool,
};

export default ItemContent;
